export const formFieldWidth = "60%";

export const arrayCurrencySymbol = [
	{ id: "$", name: "$" },
	{ id: "€", name: "€" },
	{ id: "£", name: "£" },
	{ id: "¥", name: "¥" },
	{ id: "-", name: "--------" },
	{ id: ".د.ب", name: ".د.ب" },
	{ id: ".ރ", name: ".ރ" },
	{ id: "₱", name: "₱" },
	{ id: "﷼", name: "﷼" },
	{ id: "₭", name: "₭" },
	{ id: "₦", name: "₦" },
	{ id: "₨", name: "₨" },
	{ id: "₩", name: "₩" },
	{ id: "₮", name: "₮" },
	{ id: "₡", name: "₡" },
	{ id: "৳", name: "৳" },
	{ id: "៛", name: "៛" },
	{ id: "؋", name: "؋" },
	{ id: "₲", name: "₲" },
	{ id: "₴", name: "₴" },
	{ id: "₵", name: "₵" },
	{ id: "₪", name: "₪" },
	{ id: "₫", name: "₫" },
	{ id: "₹", name: "₹" },
	{ id: "Ar", name: "Ar" },
	{ id: "B/.", name: "B/." },
	{ id: "Br", name: "Br" },
	{ id: "Bs F", name: "Bs F" },
	{ id: "Bs.", name: "Bs." },
	{ id: "C$", name: "C$" },
	{ id: "D", name: "D" },
	{ id: "Db", name: "Db" },
	{ id: "ƒ", name: "ƒ" },
	{ id: "Fr", name: "Fr" },
	{ id: "Ft", name: "Ft" },
	{ id: "G", name: "G" },
	{ id: "K", name: "K" },
	{ id: "Kč", name: "Kč" },
	{ id: "KM", name: "KM" },
	{ id: "kn", name: "kn" },
	{ id: "kr", name: "kr" },
	{ id: "Ks", name: "Ks" },
	{ id: "Kz", name: "Kz" },
	{ id: "L", name: "L" },
	{ id: "Le", name: "Le" },
	{ id: "lei", name: "lei" },
	{ id: "m", name: "m" },
	{ id: "MK", name: "MK" },
	{ id: "MT", name: "MT" },
	{ id: "Nfk", name: "Nfk" },
	{ id: "Nu.", name: "Nu." },
	{ id: "P", name: "P" },
	{ id: "Q", name: "Q" },
	{ id: "R", name: "R" },
	{ id: "R$", name: "R$" },
	{ id: "RM", name: "RM" },
	{ id: "Rp", name: "Rp" },
	{ id: "S/.", name: "S/." },
	{ id: "Sh", name: "Sh" },
	{ id: "T", name: "T" },
	{ id: "T$", name: "T$" },
	{ id: "UM", name: "UM" },
	{ id: "Vt", name: "Vt" },
	{ id: "ZK", name: "ZK" },
	{ id: "zł", name: "zł" },
	{ id: "ден", name: "ден" },
	{ id: "дин", name: "дин" },
	{ id: "ЅМ", name: "ЅМ" },
	{ id: "лв", name: "лв" },
	{ id: "ლ", name: "ლ" },
	{ id: "ج.س.", name: "ج.س." },
	{ id: "ج.م", name: "ج.م" },
	{ id: "د.إ", name: "د.إ" },
	{ id: "د.ت", name: "د.ت" },
	{ id: "د.ج", name: "د.ج" },
	{ id: "د.ك", name: "د.ك" },
	{ id: "د.م.", name: "د.م." },
	{ id: "ر.س", name: "ر.س" },
	{ id: "ر.ع.", name: "ر.ع." },
	{ id: "ر.ق", name: "ر.ق" },
	{ id: "ع.د", name: "ع.د" },
	{ id: "ل.د", name: "ل.د" },
	{ id: "ل.س", name: "ل.س" },
	{ id: "ل.ل", name: "ل.ل" },
	{ id: "රු", name: "රු" },
];

export const arrayCurrencyCode = [
	{ id: "USD", name: "USD (United States dollar)" },
	{ id: "EUR", name: "EUR (Euro)" },
	{ id: "GBP", name: "GBP (British pound)" },
	{ id: "JPY", name: "JPY (Japanese yen)" },
	{ id: "TWD", name: "TWD (New Taiwan dollar)" },
	{ id: "---", name: "-------------------------" },
	{ id: "AED", name: "AED (United Arab Emirates dirham)" },
	{ id: "AFN", name: "AFN (Afghan afghani)" },
	{ id: "ALL", name: "ALL (Albanian lek)" },
	{ id: "AMD", name: "AMD (Armenian dram)" },
	{ id: "ANG", name: "ANG (Netherlands Antillean guilder)" },
	{ id: "AOA", name: "AOA (Angolan kwanza)" },
	{ id: "ARS", name: "ARS (Argentine peso)" },
	{ id: "AUD", name: "AUD (Australian dollar)" },
	{ id: "AWG", name: "AWG (Aruban florin)" },
	{ id: "AZN", name: "AZN (Azerbaijani manat)" },
	{ id: "BAM", name: "BAM (Bosnia and Herzegovina convertible mark)" },
	{ id: "BBD", name: "BBD (Barbadian dollar)" },
	{ id: "BDT", name: "BDT (Bangladeshi taka)" },
	{ id: "BGN", name: "BGN (Bulgarian lev)" },
	{ id: "BHD", name: "BHD (Bahraini dinar)" },
	{ id: "BIF", name: "BIF (Burundian franc)" },
	{ id: "BMD", name: "BMD (Bermudian dollar)" },
	{ id: "BND", name: "BND (Brunei dollar)" },
	{ id: "BOB", name: "BOB (Bolivian boliviano)" },
	{ id: "BRL", name: "BRL (Brazilian real)" },
	{ id: "BSD", name: "BSD (Bahamian dollar)" },
	{ id: "BTN", name: "BTN (Bhutanese ngultrum)" },
	{ id: "BWP", name: "BWP (Botswana pula)" },
	{ id: "BYR", name: "BYR (Belarusian ruble)" },
	{ id: "BZD", name: "BZD (Belize dollar)" },
	{ id: "CAD", name: "CAD (Canadian dollar)" },
	{ id: "CDF", name: "CDF (Congolese franc)" },
	{ id: "CHF", name: "CHF (Swiss franc)" },
	{ id: "CLP", name: "CLP (Chilean peso)" },
	{ id: "COP", name: "COP (Colombian peso)" },
	{ id: "CRC", name: "CRC (Costa Rican colón)" },
	{ id: "CUC", name: "CUC (Cuban convertible peso)" },
	{ id: "CUP", name: "CUP (Cuban peso)" },
	{ id: "CVE", name: "CVE (Cape Verdean escudo)" },
	{ id: "CZK", name: "CZK (Czech koruna)" },
	{ id: "DJF", name: "DJF (Djiboutian franc)" },
	{ id: "DKK", name: "DKK (Danish krone)" },
	{ id: "DOP", name: "DOP (Dominican peso)" },
	{ id: "DZD", name: "DZD (Algerian dinar)" },
	{ id: "EGP", name: "EGP (Egyptian pound)" },
	{ id: "ERN", name: "ERN (Eritrean nakfa)" },
	{ id: "ETB", name: "ETB (Ethiopian birr)" },
	{ id: "FJD", name: "FJD (Fijian dollar)" },
	{ id: "FKP", name: "FKP (Falkland Islands pound)" },
	{ id: "GEL", name: "GEL (Georgian lari)" },
	{ id: "GGP", name: "GGP (Guernsey pound)" },
	{ id: "GHS", name: "GHS (Ghana cedi)" },
	{ id: "GIP", name: "GIP (Gibraltar pound)" },
	{ id: "GMD", name: "GMD (Gambian dalasi)" },
	{ id: "GNF", name: "GNF (Guinean franc)" },
	{ id: "GTQ", name: "GTQ (Guatemalan quetzal)" },
	{ id: "GYD", name: "GYD (Guyanese dollar)" },
	{ id: "HKD", name: "HKD (Hong Kong dollar)" },
	{ id: "HNL", name: "HNL (Honduran lempira)" },
	{ id: "HRK", name: "HRK (Croatian kuna)" },
	{ id: "HTG", name: "HTG (Haitian gourde)" },
	{ id: "HUF", name: "HUF (Hungarian forint)" },
	{ id: "IDR", name: "IDR (Indonesian rupiah)" },
	{ id: "ILS", name: "ILS (Israeli new shekel)" },
	{ id: "INR", name: "INR (Indian rupee)" },
	{ id: "IQD", name: "IQD (Iraqi dinar)" },
	{ id: "IRR", name: "IRR (Iranian rial)" },
	{ id: "ISK", name: "ISK (Icelandic króna)" },
	{ id: "JMD", name: "JMD (Jamaican dollar)" },
	{ id: "JOD", name: "JOD (Jordanian dinar)" },

	{ id: "KES", name: "KES (Kenyan shilling)" },
	{ id: "KGS", name: "KGS (Kyrgyzstani som)" },
	{ id: "KHR", name: "KHR (Cambodian riel)" },
	{ id: "KMF", name: "KMF (Comorian franc)" },
	{ id: "KPW", name: "KPW (North Korean won)" },
	{ id: "KRW", name: "KRW (South Korean won)" },
	{ id: "KWD", name: "KWD (Kuwaiti dinar)" },
	{ id: "KYD", name: "KYD (Cayman Islands dollar)" },
	{ id: "KZT", name: "KZT (Kazakhstani tenge)" },
	{ id: "LAK", name: "LAK (Lao kip)" },
	{ id: "LBP", name: "LBP (Lebanese pound)" },
	{ id: "LKR", name: "LKR (Sri Lankan rupee)" },
	{ id: "LRD", name: "LRD (Liberian dollar)" },
	{ id: "LSL", name: "LSL (Lesotho loti)" },
	{ id: "LYD", name: "LYD (Libyan dinar)" },
	{ id: "MAD", name: "MAD (Moroccan dirham)" },
	{ id: "MDL", name: "MDL (Moldovan leu)" },
	{ id: "MGA", name: "MGA (Malagasy ariary)" },
	{ id: "MKD", name: "MKD (Macedonian denar)" },
	{ id: "MMK", name: "MMK (Burmese kyat)" },
	{ id: "MNT", name: "MNT (Mongolian tögrög)" },
	{ id: "MOP", name: "MOP (Macanese pataca)" },
	{ id: "MRO", name: "MRO (Mauritanian ouguiya)" },
	{ id: "MUR", name: "MUR (Mauritian rupee)" },
	{ id: "MVR", name: "MVR (Maldivian rufiyaa)" },
	{ id: "MWK", name: "MWK (Malawian kwacha)" },
	{ id: "MXN", name: "MXN (Mexican peso)" },
	{ id: "MYR", name: "MYR (Malaysian ringgit)" },
	{ id: "MZN", name: "MZN (Mozambican metical)" },
	{ id: "NAD", name: "NAD (Namibian dollar)" },
	{ id: "NGN", name: "NGN (Nigerian naira)" },
	{ id: "NIO", name: "NIO (Nicaraguan córdoba)" },
	{ id: "NOK", name: "NOK (Norwegian krone)" },
	{ id: "none", name: "none (Abkhazian apsar)" },
	{ id: "NPR", name: "NPR (Nepalese rupee)" },
	{ id: "NZD", name: "NZD (New Zealand dollar)" },
	{ id: "OMR", name: "OMR (Omani rial)" },
	{ id: "PAB", name: "PAB (Panamanian balboa)" },
	{ id: "PEN", name: "PEN (Peruvian nuevo sol)" },
	{ id: "PGK", name: "PGK (Papua New Guinean kina)" },
	{ id: "PHP", name: "PHP (Philippine peso)" },
	{ id: "PKR", name: "PKR (Pakistani rupee)" },
	{ id: "PLN", name: "PLN (Polish złoty)" },
	{ id: "PYG", name: "PYG (Paraguayan guaraní)" },
	{ id: "QAR", name: "QAR (Qatari riyal)" },
	{ id: "RON", name: "RON (Romanian leu)" },
	{ id: "RSD", name: "RSD (Serbian dinar)" },
	{ id: "RUB", name: "RUB (Russian ruble)" },
	{ id: "RWF", name: "RWF (Rwandan franc)" },
	{ id: "SAR", name: "SAR (Saudi riyal)" },
	{ id: "SBD", name: "SBD (Solomon Islands dollar)" },
	{ id: "SCR", name: "SCR (Seychellois rupee)" },
	{ id: "SDG", name: "SDG (Sudanese pound)" },
	{ id: "SEK", name: "SEK (Swedish krona)" },
	{ id: "SGD", name: "SGD (Singapore dollar)" },
	{ id: "SHP", name: "SHP (Saint Helena pound)" },
	{ id: "SLL", name: "SLL (Sierra Leonean leone)" },
	{ id: "SOS", name: "SOS (Somali shilling)" },
	{ id: "SRD", name: "SRD (Surinamese dollar)" },
	{ id: "SSP", name: "SSP (South Sudanese pound)" },
	{ id: "STD", name: "STD (São Tomé and Príncipe dobra)" },
	{ id: "SYP", name: "SYP (Syrian pound)" },
	{ id: "SZL", name: "SZL (Swazi lilangeni)" },
	{ id: "THB", name: "THB (Thai baht)" },
	{ id: "TJS", name: "TJS (Tajikistani somoni)" },
	{ id: "TMT", name: "TMT (Turkmenistan manat)" },
	{ id: "TND", name: "TND (Tunisian dinar)" },
	{ id: "TOP", name: "TOP (Tongan paʻanga)" },
	{ id: "TRY", name: "TRY (Turkish lira)" },
	{ id: "TTD", name: "TTD (Trinidad and Tobago dollar)" },
	{ id: "TZS", name: "TZS (Tanzanian shilling)" },
	{ id: "UAH", name: "UAH (Ukrainian hryvnia)" },
	{ id: "UGX", name: "UGX (Ugandan shilling)" },
	{ id: "UYU", name: "UYU (Uruguayan peso)" },
	{ id: "UZS", name: "UZS (Uzbekistani som)" },
	{ id: "VEF", name: "VEF (Venezuelan bolívar)" },
	{ id: "VND", name: "VND (Vietnamese đồng)" },
	{ id: "VUV", name: "VUV (Vanuatu vatu)" },
	{ id: "WST", name: "WST (Samoan tālā)" },
	{ id: "XAF", name: "XAF (Central African CFA franc)" },
	{ id: "XCD", name: "XCD (East Caribbean dollar)" },
	{ id: "XOF", name: "XOF (West African CFA franc)" },
	{ id: "XPF", name: "XPF (CFP franc)" },
	{ id: "YER", name: "YER (Yemeni rial)" },
	{ id: "ZAR", name: "ZAR (South African rand)" },
	{ id: "ZMW", name: "ZMW (Zambian kwacha)" },
];

export const arrayCurrency = [
	{
		id: "68",
		code: "USD",
		name: "$ (USD - El Salvador)",
		symbol: "$",
		state: "El Salvador",
		currency_name: "United States dollar",
	},
	{
		id: "228",
		code: "USD",
		name: "$ (USD - United States)",
		symbol: "$",
		state: "United States",
		currency_name: "United States dollar",
	},
	{
		id: "7",
		code: "EUR",
		name: "€ (EUR - Andorra)",
		symbol: "€",
		state: "Andorra",
		currency_name: "Euro",
	},
	{
		id: "16",
		code: "EUR",
		name: "€ (EUR - Austria)",
		symbol: "€",
		state: "Austria",
		currency_name: "Euro",
	},
	{
		id: "23",
		code: "EUR",
		name: "€ (EUR - Belgium)",
		symbol: "€",
		state: "Belgium",
		currency_name: "Euro",
	},
	{
		id: "59",
		code: "EUR",
		name: "€ (EUR - Cyprus)",
		symbol: "€",
		state: "Cyprus",
		currency_name: "Euro",
	},
	{
		id: "71",
		code: "EUR",
		name: "€ (EUR - Estonia)",
		symbol: "€",
		state: "Estonia",
		currency_name: "Euro",
	},
	{
		id: "76",
		code: "EUR",
		name: "€ (EUR - Finland)",
		symbol: "€",
		state: "Finland",
		currency_name: "Euro",
	},
	{
		id: "77",
		code: "EUR",
		name: "€ (EUR - France)",
		symbol: "€",
		state: "France",
		currency_name: "Euro",
	},
	{
		id: "82",
		code: "EUR",
		name: "€ (EUR - Germany)",
		symbol: "€",
		state: "Germany",
		currency_name: "Euro",
	},
	{
		id: "85",
		code: "EUR",
		name: "€ (EUR - Greece)",
		symbol: "€",
		state: "Greece",
		currency_name: "Euro",
	},
	{
		id: "101",
		code: "EUR",
		name: "€ (EUR - Ireland)",
		symbol: "€",
		state: "Ireland",
		currency_name: "Euro",
	},
	{
		id: "104",
		code: "EUR",
		name: "€ (EUR - Italy)",
		symbol: "€",
		state: "Italy",
		currency_name: "Euro",
	},
	{
		id: "114",
		code: "EUR",
		name: "€ (EUR - Kosovo)",
		symbol: "€",
		state: "Kosovo",
		currency_name: "Euro",
	},
	{
		id: "118",
		code: "EUR",
		name: "€ (EUR - Latvia)",
		symbol: "€",
		state: "Latvia",
		currency_name: "Euro",
	},
	{
		id: "124",
		code: "EUR",
		name: "€ (EUR - Lithuania)",
		symbol: "€",
		state: "Lithuania",
		currency_name: "Euro",
	},
	{
		id: "125",
		code: "EUR",
		name: "€ (EUR - Luxembourg)",
		symbol: "€",
		state: "Luxembourg",
		currency_name: "Euro",
	},
	{
		id: "140",
		code: "EUR",
		name: "€ (EUR - Monaco)",
		symbol: "€",
		state: "Monaco",
		currency_name: "Euro",
	},
	{
		id: "142",
		code: "EUR",
		name: "€ (EUR - Montenegro)",
		symbol: "€",
		state: "Montenegro",
		currency_name: "Euro",
	},
	{
		id: "151",
		code: "EUR",
		name: "€ (EUR - Netherlands)",
		symbol: "€",
		state: "Netherlands",
		currency_name: "Euro",
	},
	{
		id: "171",
		code: "EUR",
		name: "€ (EUR - Portugal)",
		symbol: "€",
		state: "Portugal",
		currency_name: "Euro",
	},
	{
		id: "193",
		code: "EUR",
		name: "€ (EUR - Slovakia)",
		symbol: "€",
		state: "Slovakia",
		currency_name: "Euro",
	},
	{
		id: "194",
		code: "EUR",
		name: "€ (EUR - Slovenia)",
		symbol: "€",
		state: "Slovenia",
		currency_name: "Euro",
	},
	{
		id: "201",
		code: "EUR",
		name: "€ (EUR - Spain)",
		symbol: "€",
		state: "Spain",
		currency_name: "Euro",
	},
	{
		id: "227",
		code: "GBP",
		name: "£ (GBP - United Kingdom)",
		symbol: "£",
		state: "United Kingdom",
		currency_name: "British pound",
	},
	{
		id: "106",
		code: "JPY",
		name: "¥ (JPY - Japan)",
		symbol: "¥",
		state: "Japan",
		currency_name: "Japanese yen",
	},
	{
		id: "210",
		code: "TWD",
		name: "$ (TWD - Taiwan)",
		symbol: "$",
		state: "Taiwan",
		currency_name: "New Taiwan dollar",
	},
	{ id: "", name: "-------------------------" },
	{
		id: "226",
		code: "AED",
		name: "د.إ (AED - United Arab Emirates)",
		symbol: "د.إ",
		state: "United Arab Emirates",
		currency_name: "United Arab Emirates dirham",
	},
	{
		id: "2",
		code: "AFN",
		name: "؋ (AFN - Afghanistan)",
		symbol: "؋",
		state: "Afghanistan",
		currency_name: "Afghan afghani",
	},
	{
		id: "4",
		code: "ALL",
		name: "L (ALL - Albania)",
		symbol: "L",
		state: "Albania",
		currency_name: "Albanian lek",
	},
	// {
	// 	id: "12",
	// 	code: "AMD",
	// 	name: " (AMD - Armenia)",
	// 	symbol: "",
	// 	state: "Armenia",
	// 	currency_name: "Armenian dram",
	// },
	{
		id: "11",
		code: "ARS",
		name: "$ (ARS - Argentina)",
		symbol: "$",
		state: "Argentina",
		currency_name: "Argentine peso",
	},
	{
		id: "15",
		code: "AUD",
		name: "$ (AUD - Australia)",
		symbol: "$",
		state: "Australia",
		currency_name: "Australian dollar",
	},
	{
		id: "30",
		code: "BAM",
		name: "KM or КМ (BAM - Bosnia and Herzegovina)",
		symbol: "KM or КМ",
		state: "Bosnia and Herzegovina",
		currency_name: "Bosnia and Herzegovina convertible mark",
	},
	{
		id: "20",
		code: "BDT",
		name: "৳ (BDT - Bangladesh)",
		symbol: "৳",
		state: "Bangladesh",
		currency_name: "Bangladeshi taka",
	},
	{
		id: "36",
		code: "BGN",
		name: "лв (BGN - Bulgaria)",
		symbol: "лв",
		state: "Bulgaria",
		currency_name: "Bulgarian lev",
	},
	{
		id: "19",
		code: "BHD",
		name: ".د.ب (BHD - Bahrain)",
		symbol: ".د.ب",
		state: "Bahrain",
		currency_name: "Bahraini dinar",
	},
	{
		id: "38",
		code: "BIF",
		name: "Fr (BIF - Burundi)",
		symbol: "Fr",
		state: "Burundi",
		currency_name: "Burundian franc",
	},
	{
		id: "28",
		code: "BOB",
		name: "Bs. (BOB - Bolivia)",
		symbol: "Bs.",
		state: "Bolivia",
		currency_name: "Bolivian boliviano",
	},
	{
		id: "32",
		code: "BRL",
		name: "R$ (BRL - Brazil)",
		symbol: "R$",
		state: "Brazil",
		currency_name: "Brazilian real",
	},
	{
		id: "31",
		code: "BWP",
		name: "P (BWP - Botswana)",
		symbol: "P",
		state: "Botswana",
		currency_name: "Botswana pula",
	},
	{
		id: "22",
		code: "BYR",
		name: "Br (BYR - Belarus)",
		symbol: "Br",
		state: "Belarus",
		currency_name: "Belarusian ruble",
	},
	{
		id: "24",
		code: "BZD",
		name: "$ (BZD - Belize)",
		symbol: "$",
		state: "Belize",
		currency_name: "Belize dollar",
	},
	{
		id: "41",
		code: "CAD",
		name: "$ (CAD - Canada)",
		symbol: "$",
		state: "Canada",
		currency_name: "Canadian dollar",
	},
	{
		id: "123",
		code: "CHF",
		name: "Fr (CHF - Liechtenstein)",
		symbol: "Fr",
		state: "Liechtenstein",
		currency_name: "Swiss franc",
	},
	{
		id: "208",
		code: "CHF",
		name: "Fr (CHF - Switzerland)",
		symbol: "Fr",
		state: "Switzerland",
		currency_name: "Swiss franc",
	},
	{
		id: "46",
		code: "CLP",
		name: "$ (CLP - Chile)",
		symbol: "$",
		state: "Chile",
		currency_name: "Chilean peso",
	},
	{
		id: "47",
		code: "CNY",
		name: "¥ or 元 (CNY - China)",
		symbol: "¥ or 元",
		state: "China",
		currency_name: "Chinese yuan",
	},
	{
		id: "49",
		code: "COP",
		name: "$ (COP - Colombia)",
		symbol: "$",
		state: "Colombia",
		currency_name: "Colombian peso",
	},
	{
		id: "60",
		code: "CZK",
		name: "Kč (CZK - Czech Republic)",
		symbol: "Kč",
		state: "Czech Republic",
		currency_name: "Czech koruna",
	},
	{
		id: "62",
		code: "DJF",
		name: "Fr (DJF - Djibouti)",
		symbol: "Fr",
		state: "Djibouti",
		currency_name: "Djiboutian franc",
	},
	{
		id: "61",
		code: "DKK",
		name: "kr (DKK - Denmark)",
		symbol: "kr",
		state: "Denmark",
		currency_name: "Danish krone",
	},
	{
		id: "67",
		code: "EGP",
		name: "£ or ج.م (EGP - Egypt)",
		symbol: "£ or ج.م",
		state: "Egypt",
		currency_name: "Egyptian pound",
	},
	{
		id: "73",
		code: "FKP",
		name: "£ (FKP - Falkland Islands)",
		symbol: "£",
		state: "Falkland Islands",
		currency_name: "Falkland Islands pound",
	},
	{
		id: "81",
		code: "GEL",
		name: "ლ (GEL - Georgia)",
		symbol: "ლ",
		state: "Georgia",
		currency_name: "Georgian lari",
	},
	{
		id: "84",
		code: "GIP",
		name: "£ (GIP - Gibraltar)",
		symbol: "£",
		state: "Gibraltar",
		currency_name: "Gibraltar pound",
	},
	{
		id: "87",
		code: "GTQ",
		name: "Q (GTQ - Guatemala)",
		symbol: "Q",
		state: "Guatemala",
		currency_name: "Guatemalan quetzal",
	},
	{
		id: "94",
		code: "HKD",
		name: "$ (HKD - Hong Kong)",
		symbol: "$",
		state: "Hong Kong",
		currency_name: "Hong Kong dollar",
	},
	{
		id: "93",
		code: "HNL",
		name: "L (HNL - Honduras)",
		symbol: "L",
		state: "Honduras",
		currency_name: "Honduran lempira",
	},
	{
		id: "56",
		code: "HRK",
		name: "kn (HRK - Croatia)",
		symbol: "kn",
		state: "Croatia",
		currency_name: "Croatian kuna",
	},
	{
		id: "95",
		code: "HUF",
		name: "Ft (HUF - Hungary)",
		symbol: "Ft",
		state: "Hungary",
		currency_name: "Hungarian forint",
	},
	{
		id: "98",
		code: "IDR",
		name: "Rp (IDR - Indonesia)",
		symbol: "Rp",
		state: "Indonesia",
		currency_name: "Indonesian rupiah",
	},
	{
		id: "103",
		code: "ILS",
		name: "₪ (ILS - Israel)",
		symbol: "₪",
		state: "Israel",
		currency_name: "Israeli new shekel",
	},
	{
		id: "97",
		code: "INR",
		name: "₹ (INR - India)",
		symbol: "₹",
		state: "India",
		currency_name: "Indian rupee",
	},
	{
		id: "100",
		code: "IQD",
		name: "ع.د (IQD - Iraq)",
		symbol: "ع.د",
		state: "Iraq",
		currency_name: "Iraqi dinar",
	},
	{
		id: "99",
		code: "IRR",
		name: "﷼ (IRR - Iran)",
		symbol: "﷼",
		state: "Iran",
		currency_name: "Iranian rial",
	},
	{
		id: "96",
		code: "ISK",
		name: "kr (ISK - Iceland)",
		symbol: "kr",
		state: "Iceland",
		currency_name: "Icelandic króna",
	},
	{
		id: "108",
		code: "JOD",
		name: "د.ا (JOD - Jordan)",
		symbol: "د.ا",
		state: "Jordan",
		currency_name: "Jordanian dinar",
	},
	{
		id: "116",
		code: "KGS",
		name: "лв (KGS - Kyrgyzstan)",
		symbol: "лв",
		state: "Kyrgyzstan",
		currency_name: "Kyrgyzstani som",
	},
	{
		id: "112",
		code: "KPW",
		name: "₩ (KPW - Korea, North)",
		symbol: "₩",
		state: "Korea, North",
		currency_name: "North Korean won",
	},
	{
		id: "113",
		code: "KRW",
		name: "₩ (KRW - Korea, South)",
		symbol: "₩",
		state: "Korea, South",
		currency_name: "South Korean won",
	},
	{
		id: "115",
		code: "KWD",
		name: "د.ك (KWD - Kuwait)",
		symbol: "د.ك",
		state: "Kuwait",
		currency_name: "Kuwaiti dinar",
	},
	// {
	// 	id: "109",
	// 	code: "KZT",
	// 	name: " (KZT - Kazakhstan)",
	// 	symbol: "",
	// 	state: "Kazakhstan",
	// 	currency_name: "Kazakhstani tenge",
	// },
	{
		id: "117",
		code: "LAK",
		name: "₭ (LAK - Laos)",
		symbol: "₭",
		state: "Laos",
		currency_name: "Lao kip",
	},
	{
		id: "119",
		code: "LBP",
		name: "ل.ل (LBP - Lebanon)",
		symbol: "ل.ل",
		state: "Lebanon",
		currency_name: "Lebanese pound",
	},
	{
		id: "203",
		code: "LKR",
		name: "Rs or රු (LKR - Sri Lanka)",
		symbol: "Rs or රු",
		state: "Sri Lanka",
		currency_name: "Sri Lankan rupee",
	},
	{
		id: "139",
		code: "MDL",
		name: "L (MDL - Moldova)",
		symbol: "L",
		state: "Moldova",
		currency_name: "Moldovan leu",
	},
	{
		id: "127",
		code: "MKD",
		name: "ден (MKD - Macedonia, Republic of)",
		symbol: "ден",
		state: "Macedonia, Republic of",
		currency_name: "Macedonian denar",
	},
	{
		id: "141",
		code: "MNT",
		name: "₮ (MNT - Mongolia)",
		symbol: "₮",
		state: "Mongolia",
		currency_name: "Mongolian tögrög",
	},
	{
		id: "126",
		code: "MOP",
		name: "P (MOP - Macau)",
		symbol: "P",
		state: "Macau",
		currency_name: "Macanese pataca",
	},
	{
		id: "131",
		code: "MVR",
		name: ".ރ (MVR - Maldives)",
		symbol: ".ރ",
		state: "Maldives",
		currency_name: "Maldivian rufiyaa",
	},
	{
		id: "137",
		code: "MXN",
		name: "$ (MXN - Mexico)",
		symbol: "$",
		state: "Mexico",
		currency_name: "Mexican peso",
	},
	{
		id: "130",
		code: "MYR",
		name: "RM (MYR - Malaysia)",
		symbol: "RM",
		state: "Malaysia",
		currency_name: "Malaysian ringgit",
	},
	{
		id: "154",
		code: "NIO",
		name: "C$ (NIO - Nicaragua)",
		symbol: "C$",
		state: "Nicaragua",
		currency_name: "Nicaraguan córdoba",
	},
	{
		id: "159",
		code: "NOK",
		name: "kr (NOK - Norway)",
		symbol: "kr",
		state: "Norway",
		currency_name: "Norwegian krone",
	},
	{
		id: "150",
		code: "NPR",
		name: "₨ (NPR - Nepal)",
		symbol: "₨",
		state: "Nepal",
		currency_name: "Nepalese rupee",
	},
	{
		id: "153",
		code: "NZD",
		name: "$ (NZD - New Zealand)",
		symbol: "$",
		state: "New Zealand",
		currency_name: "New Zealand dollar",
	},
	{
		id: "160",
		code: "OMR",
		name: "ر.ع. (OMR - Oman)",
		symbol: "ر.ع.",
		state: "Oman",
		currency_name: "Omani rial",
	},
	{
		id: "167",
		code: "PEN",
		name: "S/. (PEN - Peru)",
		symbol: "S/.",
		state: "Peru",
		currency_name: "Peruvian nuevo sol",
	},
	{
		id: "165",
		code: "PGK",
		name: "K (PGK - Papua New Guinea)",
		symbol: "K",
		state: "Papua New Guinea",
		currency_name: "Papua New Guinean kina",
	},
	{
		id: "168",
		code: "PHP",
		name: "₱ (PHP - Philippines)",
		symbol: "₱",
		state: "Philippines",
		currency_name: "Philippine peso",
	},
	{
		id: "161",
		code: "PKR",
		name: "₨ (PKR - Pakistan)",
		symbol: "₨",
		state: "Pakistan",
		currency_name: "Pakistani rupee",
	},
	{
		id: "170",
		code: "PLN",
		name: "zł (PLN - Poland)",
		symbol: "zł",
		state: "Poland",
		currency_name: "Polish złoty",
	},
	{
		id: "166",
		code: "PYG",
		name: "₲ (PYG - Paraguay)",
		symbol: "₲",
		state: "Paraguay",
		currency_name: "Paraguayan guaraní",
	},
	{
		id: "172",
		code: "QAR",
		name: "ر.ق (QAR - Qatar)",
		symbol: "ر.ق",
		state: "Qatar",
		currency_name: "Qatari riyal",
	},
	{
		id: "173",
		code: "RON",
		name: "lei (RON - Romania)",
		symbol: "lei",
		state: "Romania",
		currency_name: "Romanian leu",
	},
	{
		id: "187",
		code: "RSD",
		name: "дин. or din. (RSD - Serbia)",
		symbol: "дин. or din.",
		state: "Serbia",
		currency_name: "Serbian dinar",
	},
	{
		id: "174",
		code: "RUB",
		name: "₽ (RUB - Russia)",
		symbol: "₽",
		state: "Russia",
		currency_name: "Russian ruble",
	},
	{
		id: "185",
		code: "SAR",
		name: "ر.س (SAR - Saudi Arabia)",
		symbol: "ر.س",
		state: "Saudi Arabia",
		currency_name: "Saudi riyal",
	},
	{
		id: "207",
		code: "SEK",
		name: "kr (SEK - Sweden)",
		symbol: "kr",
		state: "Sweden",
		currency_name: "Swedish krona",
	},
	{
		id: "190",
		code: "SGD",
		name: "$ (SGD - Singapore)",
		symbol: "$",
		state: "Singapore",
		currency_name: "Singapore dollar",
	},
	{
		id: "213",
		code: "THB",
		name: "฿ (THB - Thailand)",
		symbol: "฿",
		state: "Thailand",
		currency_name: "Thai baht",
	},
	{
		id: "221",
		code: "TMT",
		name: "m (TMT - Turkmenistan)",
		symbol: "m",
		state: "Turkmenistan",
		currency_name: "Turkmenistan manat",
	},
	{
		id: "220",
		code: "TRY",
		name: "₺ (TRY - Turkey)",
		symbol: "₺",
		state: "Turkey",
		currency_name: "Turkish lira",
	},
	// {
	// 	id: "158",
	// 	code: "TRY",
	// 	name: " (TRY - Northern Cyprus)",
	// 	symbol: "",
	// 	state: "Northern Cyprus",
	// 	currency_name: "Turkish lira",
	// },
	{
		id: "225",
		code: "UAH",
		name: "₴ (UAH - Ukraine)",
		symbol: "₴",
		state: "Ukraine",
		currency_name: "Ukrainian hryvnia",
	},
	{
		id: "229",
		code: "UYU",
		name: "$ (UYU - Uruguay)",
		symbol: "$",
		state: "Uruguay",
		currency_name: "Uruguayan peso",
	},
	// {
	// 	id: "230",
	// 	code: "UZS",
	// 	name: " (UZS - Uzbekistan)",
	// 	symbol: "",
	// 	state: "Uzbekistan",
	// 	currency_name: "Uzbekistani som",
	// },
	{
		id: "233",
		code: "VEF",
		name: "Bs F (VEF - Venezuela)",
		symbol: "Bs F",
		state: "Venezuela",
		currency_name: "Venezuelan bolívar",
	},
	{
		id: "234",
		code: "VND",
		name: "₫ (VND - Vietnam)",
		symbol: "₫",
		state: "Vietnam",
		currency_name: "Vietnamese đồng",
	},
	{
		id: "25",
		code: "XOF",
		name: "Fr (XOF - Benin)",
		symbol: "Fr",
		state: "Benin",
		currency_name: "West African CFA franc",
	},
	{
		id: "37",
		code: "XOF",
		name: "G (XOF - Burkina Faso)",
		symbol: "G",
		state: "Burkina Faso",
		currency_name: "West African CFA franc",
	},
	{
		id: "152",
		code: "XPF",
		name: "Fr (XPF - New Caledonia)",
		symbol: "Fr",
		state: "New Caledonia",
		currency_name: "CFP franc",
	},
	{
		id: "236",
		code: "YER",
		name: "﷼ (YER - Yemen)",
		symbol: "﷼",
		state: "Yemen",
		currency_name: "Yemeni rial",
	},
];

export const arrayCurrencyUnit = [
	{ id: "M", name: "M (Million)", label: "M (Million)" },
	{ id: "B", name: "B (Billion)", label: "B (Billion)" },
	{ id: "T", name: "T (Trillion)", label: "T (Trillion)" },
];